export class ILookup<Key = string, Value = string> {
    public id: Key;
    public text: Value;

}
